import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Typography, Breadcrumbs } from '@mui/material';

import { makeStyles } from '@mui/styles';

import { Link, NavLink, useLocation } from 'react-router-dom';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

// Custom components
import { GridGroup } from './components';

// Component styles
import styles from './styles';
import { useIntl } from 'react-intl';
import theme from 'theme';
import { showGroups } from 'js/actions/groupActions';
const useStyles = makeStyles(styles);

export default function Groups() {
  const intl = useIntl();
  const location = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const corporative = location.state;

  useEffect(() => {
    dispatch(
      showGroups(
        corporative.corporative_id
          ? corporative.corporative_id
          : corporative.meter.corporative_id
      )
    );
  }, [corporative]);

  return (
    <DashboardLayout
      chargeName={corporative ? corporative.name : null}
      title={'Grupos'}
    >
      <div className={classes.root}>
        <Typography
          style={{ color: '#A53693', marginBottom: theme.spacing(2) }}
          variant="h2"
        >
          {intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
        </Typography>
        <Breadcrumbs
          aria-label="breadcrumb"
          className={classes.breadcrumb}
          separator=":"
          sx={{ marginTop: '0px' }}
        >
          <Link
            color="inherit"
            component={NavLink}
            style={{ color: '#A53693' }}
            to={`/corporative/${corporative.corporative_id ? corporative.corporative_id : corporative.meter.corporative_id}`}
            state={corporative}
          >
            {intl.formatMessage({ id: 'app.groups.nav.meters' })}
          </Link>

          <Typography className={classes.description} variant="h5">
            {corporative
              ? corporative.name
                ? corporative.name
                : corporative.meter.name
              : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
          </Typography>
        </Breadcrumbs>
        <div className={classes.content}>
          <GridGroup
            meter={corporative.corporative_id ? corporative : corporative.meter}
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
